import { render } from "./FilterLeadModal.vue?vue&type=template&id=60f18a4e&ts=true"
import script from "./FilterLeadModal.vue?vue&type=script&lang=ts"
export * from "./FilterLeadModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__